import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { FormControl, Validators } from '@angular/forms';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ManageUser } from '../../../models/centre/manage-user.model';
import { Page } from '../../../models/list/page.model';
import { VaccineModel } from '../../../models/master-data/vaccines.model';
import { UserUrl } from '../../../shared/urls/user.url';
import { UserType } from '../../../shared/constants/permission';
import { ManageVaccineAddPopupComponent } from './manage-vaccine-add-popup.component';
import { ManageVaccineEditPopupComponent } from './manage-vaccine-edit-popup.component';
import { VaccineStockModel } from '../../../models/master-data/vaccine-stock.model';
import * as moment from 'moment';
import { ManageVaccineService } from './manage-vaccine.service';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';
@Component({
  selector: 'manage-vaccine',
  templateUrl: 'manage-vaccine.component.html',
  providers: [ManageVaccineService]
})

export class ManageVaccineComponent extends TMBDataTableComponent implements OnInit {
  public listVaccine: any;
  public listCentre: any;
  public isSystemAdmin = false;
  public filterData = { vaccineId: null, centreId: null, showExpired: false };
  public totalStock = 0;

  constructor(public utility: Utility, sharedService: SharedService,
    public manageVaccineService: ManageVaccineService,
    public dialogService: DialogService) {
    super(sharedService);
  }

  ngOnInit() {
    // init temporary data
    if (localStorage.getItem(AppConstants.localStorage.userType) === UserType.SystemAdmin) {
      this.isSystemAdmin = true;
    }
    this.filterData.centreId = localStorage.getItem(AppConstants.localStorage.centreId);
    // Get centre
    if (this.isSystemAdmin) {
      this.getCentres();
    } else {
      this.getVaccines(this.filterData.centreId);
    }
  }

  getVaccines(centreid) {
    this.manageVaccineService.getListVaccine(centreid).subscribe(result => {
      if (result) {
        this.filterData.vaccineId = null;
        const data = result.json();
        this.listVaccine = data;
        if (this.listVaccine.length !== 0) {
          this.filterData.vaccineId = data[0].id;
        }
        this.setPage({ offset: 0 });
      }
    });
  }

  getCentres() {
    this.manageVaccineService.getCentres().subscribe(result => {
      if (result) {
        const data = result.json();
        this.listCentre = data['list'];
        if (this.listCentre) {
          this.filterData.centreId = this.listCentre[0].id;
          this.getVaccines(this.filterData.centreId);
        }
      }
    });
  }

  getDataBatch(param) {
    this.manageVaccineService.getDataBatch(param).subscribe(result => {
      if (result) {
        const data = result.json();
        this.page.totalElements = data['totalRecords'];
        this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
        this.dataRow = data['list'];
        this.totalStock = data['totalCount'];
        /*  // check if vaccine is expired
         const currentDate = new Date();
         for (let i = 0; i < this.dataRow.length; i++) {
           this.dataRow[i]['isExpired'] = moment(this.utility.convertDateToLocalString(this.dataRow[i]['expiredDate'])).isBefore(currentDate);
         //  const local = moment(this.utility.convertDateToLocalString(this.dataRow[i]['expiredDate'])).isBefore(currentDate);
         } */
      }
    });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      selectedVaccine: this.filterData.vaccineId,
      selectedCentre: this.filterData.centreId === 'null' ? '' : this.filterData.centreId,
      isShowExperied: this.filterData.showExpired
    };
    this.getDataBatch(param);

  }

  onVaccineChange() {
    this.setPage({ offset: 0 });
  }

  onCentreChange() {
    // Get vaccine
    this.getVaccines(this.filterData.centreId);
  }

  onShowExpiredChange() {
    this.setPage({ offset: 0 });
  }

  openAddVaccinePopup() {
    const param = {
      vaccineId: this.filterData.vaccineId,
      centreId: this.filterData.centreId || localStorage.getItem('centre_id')
    };
    this.dialogService.openComponentDialog(ManageVaccineAddPopupComponent, param).subscribe(result => {
      if (result) {

        // Reload list vaccine
        this.manageVaccineService.getListVaccine(param.centreId).subscribe(result => {
          if (result) {
            const data = result.json();
            this.listVaccine = data;
          }
        });

        this.reloadPage(this.page.pageNumber, this.dataRow);

      }
    });
  }

  openEditVaccinePopup(vaccine) {
    if (vaccine) {
      const param = {
        vaccineStock: vaccine,
        id: vaccine.id,
        vaccineId: this.filterData.vaccineId || null,
        centreId: this.filterData.centreId || localStorage.getItem('centre_id')
      };
      this.dialogService.openComponentDialog(ManageVaccineEditPopupComponent, param).subscribe(result => {
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      });
    }
  }

  onRemoveVaccine(vaccineId) {
    if (vaccineId) {
      const data = {
        id: vaccineId
      };
      this.dialogService.openConfirmationDialog({ message: AppMessages.vaccine.removeVaccine }).subscribe(result => {
        // call api delete vaccine
        if (result) {
          this.manageVaccineService.removeVaccineBatch(vaccineId).subscribe(
            result1 => {
              if (result1) {
                this.reloadPage(this.page.pageNumber, this.dataRow, true);
              }
            }
          );
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-vaccine/manage-vaccine.component.ts